export const COLORS = {
    primCol: '#520ca7', //'#c58164',
    primBG: 'lightblue' //VIN Color '#520ca7'
};
  